function buildRebookingRequestBody(payload) {
  return {
    data: {
      type: "order_rebookings",
      relationships: {
        requester: {
          data: {
            type: payload.requester.type,
            id: payload.requester.id
          }
        },
        order: {
          data: {
            type: "orders",
            id: payload.order.id
          }
        },
        from_professional: {
          data: {
            type: "professionals",
            id: payload.order.professional.id
          }
        },
        to_professional: {
          data: {
            type: "professionals",
            id: payload.toProfessional.id
          }
        },
        from_schedule_event: {
          data: {
            type: "schedule_events",
            id: payload.order.schedule_event.id
          }
        },
        to_schedule_event: {
          data: {
            type: "schedule_events",
            id: payload.toScheduleEvent.id
          }
        }
      }
    }
  };
}

function buildReschedulingRequestBody(payload) {
  let body = buildRebookingRequestBody(payload);
  body.data.type = "order_reschedulings";
  delete body.data.relationships.to_professional;
  delete body.data.relationships.from_professional;
  return body;
}

function buildRescheduleRequestBody(payload) {
  return {
    meta: {
      new_starts_at: payload.newStartsAt,
      new_ends_at: payload.newEndsAt
    }
  };
}

export default {
  buildRebookingRequestBody,
  buildReschedulingRequestBody,
  buildRescheduleRequestBody
};



// WEBPACK FOOTER //
// ./src/API/helpers/orders.js